import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {YouthPlayer} from "@/modules/youth/entity";
import {Team} from "@/modules/team/entity";
import {YouthPlayerTransferator} from "@/modules/youth/services/YouthPlayerTransferator";

@injectable()
export class NewcomerRecruiter {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(YouthPlayerTransferator) private youthPlayerTransferator: YouthPlayerTransferator,
  ) {}

  // count of players which can be recruited/transferred at the start of a season
  public async getLimit(team: Team) {
    return await Promise.resolve(2); // todo
  }

  public async getPlayerCount(team: Team) {
    return await Promise.resolve(7); // todo
  }

  public async transfer(player: YouthPlayer, team: Team) {
    await this.youthPlayerTransferator.transfer(player, team);
  }
}